var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.109375,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#FFD300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60938 5.7777L5.49805 7.66659L8.60916 4.33325",
    stroke: "#fff",
    strokeWidth: 1.33333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReached);
export default __webpack_public_path__ + "static/media/reached.ed4edfcd0d6b2cf5103d5fadf5f1b973.svg";
export { ForwardRef as ReactComponent };